import { isMobileAndInMvpOrExistingUsersExperiment } from '@atlassian/jira-mobile-web/src/index.tsx';
import type { RouteName } from '@atlassian/jira-route-types/src/RouteName.tsx';

const allowedRoutes: Set<RouteName> = new Set([
	'classic-business-summary',
	'classic-business-timeline',
	'classic-business-approvals',
	'classic-business-list',
	'classic-business-board',
	'classic-business-calendar',
	'classic-business-form',
	'classic-business-form-builder',
	'project-pages',
]);

export const shouldRouteShowQuickstartOnboarding = (routeName: RouteName) => {
	if (isMobileAndInMvpOrExistingUsersExperiment()) {
		return false;
	}

	return allowedRoutes.has(routeName);
};
